import "./App.css";
import {  RouterProvider } from "react-router-dom";
import browserRouter from "./routes/AppRoutes";




function App() {
  return (
    <>
      <RouterProvider router={browserRouter} />
    </>
  );
}

export default App;